export default "__VITE_ASSET__Dyaqnvdq__"